import type { RouteConfig } from '@/types/routestypes'
import { lazy } from 'react'

const Branches = lazy(() => import("@/pages/OrganizationalUnits/Branches/Branches"));
const Department = lazy(() => import("@/pages/OrganizationalUnits/Department/Department"));
const Designation = lazy(() => import("@/pages/OrganizationalUnits/Designation/Designation"));

const OrganizationalunitsRoute: RouteConfig = {
    path: "organizational-units",
    pageName: "Organizational Units",
    sidebar: { show: true, icon: "" },
    permission: ["ManageOrganizationalUnits"],
    children: {
        DEPARTMENT: {
            path: "department",
            pageName: "Department",
            element: <Department />,
            sidebar: { show: true, icon: "" },
        },
        DESIGNATION: {
            path: "designation",
            pageName: "Designation",
            element: <Designation />,
            sidebar: { show: true },
        },
        BRANCHES: {
            path: "branches",
            element: <Branches />,
            pageName: "Branches",
            sidebar: { show: true },
        },
    }
}

export default OrganizationalunitsRoute
